<template>
	<div class="content">
		<div class="tab" :style="{ minWidth: '550px' }">
			<a :href="hrefUrl" target="_self">{{ city }}58同城> </a>
			<div
				:class="{
					'tab-item': true,
					'tab-item-active': activeIndex === index
				}"
				v-for="(item, index) in subListData"
				:key="index"
				@click="activeIndex !== index && handleClick(index, item.tagId)"
			>
				{{ item.tagName }}
			</div>
		</div>
		<div class="job" :style="{ minWidth: '550px' }"><div>职位</div></div>
		<div v-if="jobListData.length > 0" :style="{ minWidth: '500px' }">
			<Item
				class="card"
				:style="{ minWidth: '550px' }"
				v-for="(item, index) in jobListData"
				:item="item"
				:pid="pid"
				:key="index"
			/>
			<div v-show="isLoading" class="division">数据加载中...</div>
			<div v-show="lastPage" class="division">到底了</div>
		</div>
		<div v-else :style="{ minWidth: '750px' }" class="no-data">
			当前职位暂无数据，换个职位看看吧！
		</div>
	</div>
</template>

<script>
import { computed, reactive, ref, toRefs } from '@vue/composition-api';
import Item from '@/components/Item/index.vue';
import cookie from '@/util/cookie';
export default {
	name: 'List',
	components: { Item },
	props: {
		subListData: {
			type: Array
		},
		jobListData: {
			type: Array
		},
		pid: {
			type: String,
			default: ''
		},
		lastPage: {
			type: Boolean
		},
		city: {
			type: String,
			default: '北京'
		}
	},
	emits: ['getData'],
	mounted() {
		this.onscroll();
	},

	setup(props, ctx) {
		const { subListData, pid, lastPage } = toRefs(props);
		const activeIndex = ref(0);
		const isLoading = ref(false); //loading加载
		const tagIdRef = ref('');

		const hrefUrl = computed(() => {
			const city = cookie.get('city') || cookie.get('58home') || 'bj';
			return `https://${city}.58.com/`;
		});

		const params = reactive({
			page: 1,
			pageSize: '50',
			pageType: 'zpchihewanle',
			pid: '',
			dispcateid: tagIdRef,
			type: 'getHeadImage,getSlideImage,getTradeTab,getInfoList'
		});

		const handleClick = (index, tagId) => {
			activeIndex.value = index;
			tagIdRef.value = tagId;
			params.page = 1;
			params.type = 'getInfoList';
			params.pid = pid.value;
			ctx.emit('getData', params, 'changedispcateid');
		};

		// 获取当前滚动条的纵坐标
		const getScrollTop = () => {
			let scrollTop = 0;
			if (
				document.documentElement &&
				document.documentElement.scrollTop
			) {
				scrollTop = Math.ceil(document.documentElement.scrollTop);
			} else if (document.body) {
				scrollTop = Math.ceil(document.body.scrollTop);
			}
			return scrollTop;
		};
		//获取当前可视范围的高度
		const getClientHeight = () => {
			let clientHeight = 0;
			if (document.documentElement.clientHeight) {
				clientHeight = Math.ceil(document.documentElement.clientHeight);
			} else {
				clientHeight = Math.ceil(document.body.clientHeight);
			}
			return clientHeight;
		};
		//获取文档完整的高度(滚动高度)
		const getScrollHeight = () => {
			return Math.floor(
				Math.max(
					document.body.scrollHeight,
					document.documentElement.scrollHeight
				)
			);
		};

		//监听滚动事件
		const onscroll = () => {
			window.onscroll = async function () {
				if (getScrollTop() + getClientHeight() >= getScrollHeight()) {
					if (!lastPage.value) {
						isLoading.value = true;
						tagIdRef.value = tagIdRef.value
							? tagIdRef.value
							: subListData.value[0]?.tagId;
						params.page++;
						params.type = 'getInfoList';
						params.pid = pid.value;
						ctx.emit('getData', params);
					} else {
						isLoading.value = false;
					}
				}
			};
		};

		return {
			activeIndex,
			tagIdRef,
			params,
			isLoading,
			hrefUrl,
			handleClick,
			onscroll,
			getScrollTop,
			getClientHeight,
			getScrollHeight
		};
	}
};
</script>

<style lang="scss">
.content {
	margin-top: 60px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	.tab {
		width: 892px;
		a {
			height: 27px;
			line-height: 27px;
			// font-family: PingFangSC-Regular;
			font-size: 19px;
			font-weight: normal;
			color: rgba(102, 102, 102, 1);
			text-align: left;
			margin-right: 18px;
		}
		.tab-item {
			margin-right: 13px;
			display: inline-block;
			box-sizing: border-box;
			width: 176px;
			padding: 8px 16px;
			// font-family: PingFangSC-Regular;
			font-size: 20px;
			font-weight: normal;
			color: rgba(102, 102, 102, 1);
			border: 1px solid rgba(102, 102, 102, 1);
			border-radius: 4px;
			text-align: center;
		}
		.tab-item-active {
			padding: 10px 14px;
			color: rgba(255, 255, 255, 1);
			border: none;
			background: linear-gradient(
				116.4deg,
				rgba(255, 112, 55, 1) 0%,
				rgba(255, 112, 55, 1) 2%,
				rgba(255, 28, 105, 1) 81%,
				rgba(255, 28, 105, 1) 100%
			);
		}
	}
	.job {
		margin-top: 44px;
		width: 892px;
		border-bottom: 1px solid #ff1c69;
		text-align: left;
		div {
			box-sizing: border-box;
			width: 135px;
			height: 45px;
			// font-family: PingFangSC-Regular;
			font-size: 20px;
			font-weight: normal;
			color: rgba(255, 255, 255, 1);
			text-align: center;
			line-height: 45px;
			border-radius: 4px 4px 0 0;
			background: linear-gradient(
				116.4deg,
				rgba(255, 112, 55, 1) 0%,
				rgba(255, 112, 55, 1) 2%,
				rgba(255, 28, 105, 1) 81%,
				rgba(255, 28, 105, 1) 100%
			);
		}
	}
	.no-data {
		font-size: 18px;
		margin-top: 30px;
		text-align: center;
	}
	.card {
		width: 892px;
		height: 180px;
		background-color: rgba(255, 255, 255, 1);
		margin-top: 15px;
		display: flex;
		flex-direction: column;
		padding: 29px 19px;
		box-shadow: 0 3px 10px rgb(0 0 0 / 6%), 0 4px 8px rgb(0 0 0 / 6%),
			0 4px 8px rgb(0 0 0 / 6%), 0 4px 8px rgb(0 0 0 / 6%);
		border-radius: 12px;
	}
}
</style>
